import { useState, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { FaPhone } from "react-icons/fa"; // <- import phone icon
import "./delete-account.sass";

export default function DeleteAccount() {
  const { t, i18n } = useTranslation();
  const [phone, setPhone] = useState("+");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const captchaKey = '6LfSMQUkAAAAAHikNnjkI2WAMi9S-GfcU23cZ3LD';

  const submit = async (e: any) => {
    e.preventDefault();
    if (!recaptchaToken) {
      setMessage(t("captcha_required"));
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      await axios.post(
        "/api/user-management-service/public/user/request-deletion",
        {
          phone,
          lang: i18n.language,
          reCaptchaToken: recaptchaToken,
        }
      );

      setMessage(t("delete_success"));
      recaptchaRef.current?.reset();
      setRecaptchaToken("");
    } catch {
      setMessage(t("delete_error"));
      recaptchaRef.current?.reset();
      setRecaptchaToken("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="delete-account-container">
      <h1 className="delete-account-title">{t("delete_title")}</h1>
      <p className="delete-account-description">{t("delete_description")}</p>

      <form className="delete-account-form" onSubmit={submit}>
       <label className="delete-account-label">
  {t("delete_phone_label")}:
</label>

<div className="input-container">
  <FaPhone className="input-icon" /> 
  <input
    type="text"
    className="delete-account-input"
    value={phone}
    onChange={(e) => setPhone(e.target.value)}
    placeholder={t("delete_phone_placeholder")}
    required
  />

        </div>

        {/* reCAPTCHA */}
        <div className="captcha">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={captchaKey}
            onChange={(token) => setRecaptchaToken(token || "")}
          />
        </div>

        <button
          type="submit"
          className="delete-account-button"
          disabled={loading}
        >
          {loading ? "..." : t("delete_button")}
        </button>
      </form>

      {message && <p className="delete-account-message">{message}</p>}
    </div>
  );
}
